"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _formElements = require("@evidation/form-elements");
var _TextInput = require("./TextInput");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _hintText = _interopRequireDefault(require("./hintText"));
var _lib = require("../../lib");
var _utils = require("../utils");
var _excluded = ["required", "label", "labelStyle", "error", "labelTooltip", "name", "id", "className", "unit", "hint_text", "srOnly", "showErrorBorder", "onBlur", "onInputBlur", "schemaHasHeading", "numberOfInputs"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var NumberInput = /*#__PURE__*/function (_Component) {
  function NumberInput() {
    (0, _classCallCheck2["default"])(this, NumberInput);
    return _callSuper(this, NumberInput, arguments);
  }
  (0, _inherits2["default"])(NumberInput, _Component);
  return (0, _createClass2["default"])(NumberInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        required = _this$props.required,
        label = _this$props.label,
        labelStyle = _this$props.labelStyle,
        error = _this$props.error,
        labelTooltip = _this$props.labelTooltip,
        name = _this$props.name,
        id = _this$props.id,
        className = _this$props.className,
        _this$props$unit = _this$props.unit,
        unit = _this$props$unit === void 0 ? '' : _this$props$unit,
        hint_text = _this$props.hint_text,
        srOnly = _this$props.srOnly,
        _this$props$showError = _this$props.showErrorBorder,
        showErrorBorder = _this$props$showError === void 0 ? true : _this$props$showError,
        onBlur = _this$props.onBlur,
        onInputBlur = _this$props.onInputBlur,
        schemaHasHeading = _this$props.schemaHasHeading,
        numberOfInputs = _this$props.numberOfInputs,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])('number-input--container', error && showErrorBorder && 'evi--fieldset-error')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "number-input--field-container"
      }, !schemaHasHeading && numberOfInputs === 1 ? /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleLegend, {
        schemaHasHeading: schemaHasHeading,
        numberOfInputs: numberOfInputs
      }, (0, _utils.stripHtml)(label)) : /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: id || "id_".concat(name),
        className: "basic-label"
      }, (0, _utils.stripHtml)(label || '')), hint_text ? /*#__PURE__*/_react["default"].createElement(_hintText["default"], {
        text: hint_text,
        id: "t-".concat(name, "_hint")
      }) : null, /*#__PURE__*/_react["default"].createElement("div", {
        role: "alert",
        id: "t-".concat(name, "_error-message_")
      }, error && showErrorBorder && /*#__PURE__*/_react["default"].createElement(_lib.InputError, null, error)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "number-input--field"
      }, /*#__PURE__*/_react["default"].createElement(_TextInput.Input, (0, _extends2["default"])({
        id: id || "id_".concat(name)
      }, rest, {
        "aria-details": 'number-input-unit',
        type: "tel",
        inputMode: "numeric",
        pattern: "^-?[0-9]\\d*(\\.\\d+)?$",
        "aria-required": required,
        required: required,
        className: (0, _clsx["default"])('number-input--input', className, error && 'evi-error--border'),
        "aria-describedby": "t-".concat(name, "_error-message_ ").concat(hint_text && "t-".concat(name, "_hint")),
        step: "any",
        onBlur: onInputBlur
      })), unit && /*#__PURE__*/_react["default"].createElement("div", {
        className: "number-input--unit-container"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        role: "definition",
        id: "number-input-unit"
      }, unit)))));
    }
  }]);
}(_react.Component);
NumberInput.propTypes = {
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].oneOf(_constants.TextInputTypes),
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object,
  error: _propTypes["default"].string
};
NumberInput.defaultProps = {
  inputStyle: "achievement",
  labelStyle: "dark",
  style: {},
  error: "",
  value: ""
};
var _default = exports["default"] = NumberInput;